export default __webpack_public_path__ + "web/images/LogoText.svg";